import { jsx } from "react/jsx-runtime";
import React from "react";
import cx from "classnames";
import { IconBaseElement } from "./IconBase.mjs";
const SSRIcon = (props) => {
  const {
    prefix = "",
    viewBox = "0 0 24 24",
    paths,
    className,
    modifier,
    ariaHidden = true,
    ...otherProps
  } = props;
  const cssStyles = cx(className, modifier && `${prefix}svg-icon--${modifier}`);
  return paths ? /* @__PURE__ */ jsx(
    IconBaseElement,
    {
      viewBox,
      prefix,
      ...otherProps,
      className: cssStyles,
      ariaHidden,
      children: paths().map((path, id) => {
        return React.cloneElement(path, { key: id });
      })
    }
  ) : null;
};
var SSRIcon_default = SSRIcon;
export {
  SSRIcon_default as default
};
